import Api from '../../api/index'

const Client = {
  namespaced: true,
  state: {
    value: 'my value',

    oneClient: null, //to store SHOW response
    allClients: null, //to store INDEX response

    // Paginação
    pagination: {
      current_page: 1,
      per_page: 20,
      total_count: 0,
      total_pages: 0
    },

    //promises results
    createClientWasGood: null,
    createClientMessage: null,

    updateClientWasGood: null,
    updateClientMessage: null,

     // less used
    indexClientWasGood: null,
    indexClientMessage: null,

    showClientWasGood: null,
    showClientMessage: null,
  },
  getters: {
    getStateValue: state => {
      return state.value;
    }
  },

  mutations: {
    setOneClient(state, Client){
      state.oneClient = Client.data.attributes // Client.data
    },
    setAllClients(state, response){
      state.allClients = response.data.map(obj=>obj.attributes) // response.data

      // Atualizar paginação se meta existir
      if (response.meta) {
        state.pagination = {
          current_page: response.meta.current_page || 1,
          per_page: response.meta.per_page || 20,
          total_count: response.meta.total_count || 0,
          total_pages: response.meta.total_pages || 0
        };
      }
    },

    createResponse(state, {was_good, msg}){
      state.createClientWasGood = was_good
      state.createClientMessage = msg
      setTimeout(() => {
        state.createClientWasGood = null
      }, 100);
    },
    updateResponse(state, {was_good, msg}){
      state.updateClientWasGood = was_good
      state.updateClientMessage = msg
      setTimeout(() => {
        state.updateClientWasGood = null
      }, 100);
    },
    indexResponse(state, {was_good, msg}){
      state.indexClientWasGood = was_good
      state.indexClientMessage = msg
      setTimeout(() => {
        state.indexClientWasGood = null
      }, 100);
    },
    showResponse(state, {was_good, msg}){
      state.showClientWasGood = was_good
      state.showClientMessage = msg
      setTimeout(() => {
        state.showClientWasGood = null
      }, 100);
    },

    clearAllClients(state){
      state.allClients = null
    },
    clearOneClient(state){
      state.oneClient = null
    },
  },

  actions: {
    clearAllClients({commit}){
      commit('clearAllClients')
    },
    clearOneClient({commit}){
      commit('clearOneClient')
    },

    index(context, params = {}) {
      Api.Client.index(params)
        .then(response => response.data)
        .then(clientsResponse => {
          context.commit('setAllClients', clientsResponse);
          context.commit('indexResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          const errorMsg = (error.response && error.response.data && error.response.data.errors && error.response.data.errors[0]) || 'Erro ao carregar clientes';
          context.commit('indexResponse', {msg: errorMsg, was_good: false});
          console.log(error);
        });
    },
    show(context, Client_id) {
      Api.Client.show(Client_id)
        .then(response => response.data)
        .then(Client => {
          context.commit('setOneClient', Client);
          context.commit('showResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('showResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    create(context, new_Client) {
      Api.Client.create(new_Client)
        .then(response => response.data)
        .then(Client => {
          // context.commit('setOneClients', Client); // not often used
          context.commit('createResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          let errorMsg = 'Erro ao criar cliente';
          if (error.response && error.response.data && error.response.data.errors) {
            // Se for um objeto de erros de validação
            if (typeof error.response.data.errors === 'object') {
              const errorKeys = Object.keys(error.response.data.errors);
              if (errorKeys.length > 0) {
                const firstError = error.response.data.errors[errorKeys[0]];
                errorMsg = Array.isArray(firstError) ? firstError[0] : firstError;
              }
            } else if (Array.isArray(error.response.data.errors)) {
              errorMsg = error.response.data.errors[0];
            }
          }
          context.commit('createResponse', {msg: errorMsg, was_good: false});
          console.log(error);
        });
    },
    update(context, Client) {
      Api.Client.update(Client)
        .then(response => response.data)
        .then(Client => {
          // context.commit('setOneClient', Client); // not often used
          context.commit('updateResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          let errorMsg = 'Erro ao atualizar cliente';
          if (error.response && error.response.data && error.response.data.errors) {
            // Se for um objeto de erros de validação
            if (typeof error.response.data.errors === 'object') {
              const errorKeys = Object.keys(error.response.data.errors);
              if (errorKeys.length > 0) {
                const firstError = error.response.data.errors[errorKeys[0]];
                errorMsg = Array.isArray(firstError) ? firstError[0] : firstError;
              }
            } else if (Array.isArray(error.response.data.errors)) {
              errorMsg = error.response.data.errors[0];
            }
          }
          context.commit('updateResponse', {msg: errorMsg, was_good: false});
          console.log(error);
        });
    },

    updateToDelete(context, Client) {
      Api.Client.updateToDelete(Client)
        .then(response => response.data)
        .then(Client => {
          // context.commit('setOneClient', Client); // not often used
          context.commit('updateResponse', {msg: 'Apagado com sucesso', was_good: true});
        }).catch(function(error) {
          context.commit('updateResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
  }

};

export default Client;